import * as types from '../mutation-types';

const state = {
  requests: 0
};

const getters = {
  ActiveHttpRequests: state => state.requests
};

const actions = {
  addHttpRequest({ commit }) {
    commit(types.ADD_HTTP_REQUEST);
  },
  removeHttpRequest({ commit }) {
    commit(types.REMOVE_HTTP_REQUEST);
  }
};

const mutations = {
  [types.ADD_HTTP_REQUEST](state) {
    state.requests++;
  },
  [types.REMOVE_HTTP_REQUEST](state) {
    if (state.requests > 0) {
      state.requests--;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
